import React from "react";
import PropTypes from "prop-types";
import { NavigationMenu } from "../NavigationMenu";

/**
 * NavigationList: List of navigation points in NavigationBar
 */
export function NavigationList(props) {
  const totalMenus = props.menuList.length;

  const makeTitle = (index) => `${index + 1}`;

  const isMenuActive = (scrollIndex) => props.scrollTip >= scrollIndex;

  const renderScrollMenu = (scrollIndex, key) => (
    <NavigationMenu
      key={key}
      title={makeTitle(key)}
      totalMenus={totalMenus}
      scrollIndex={scrollIndex}
      goToSection={props.goToSection}
      menuActive={isMenuActive(scrollIndex)}
    />
  );

  return props.menuList.map(renderScrollMenu);
}

NavigationList.propTypes = {
  /**
   * list of points user can navigatet to
   */
  menuList: PropTypes.arrayOf(PropTypes.number).isRequired,
  /**
   * callback function to be executed when clicked on a navigation point
   */
  goToSection: PropTypes.func,
  /**
   * current scrollPoint tip
   */
  scrollTip: PropTypes.number.isRequired,
};
